// extracted by mini-css-extract-plugin
export var hasBorder = "velXv3FF";
export var logo = "CpMtMpPm";
export var main = "Qo5KTq8H";
export var langSwitch = "FVG2DtyN";
export var langItem = "K29Dxpim";
export var disabled = "G9eDKpTr";
export var navbarBurger = "AvpGAEz7";
export var progress = "vT+zSIDm";
export var show = "bkxVR5m-";